module.exports = __webpack_public_path__ + "img/timeline.ae72f3be.gif";